var React = require('react');

function TestimonialsNavRight (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_2434_3831)","key":0},[React.createElement("circle",{"cx":"22","cy":"22","r":"21.5","transform":"rotate(90 22 22)","stroke":"#E4032E","key":0}),React.createElement("path",{"d":"M26 22L20 16L18.59 17.41L23.17 22L18.59 26.59L20 28L26 22Z","fill":"#E4032E","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_2434_3831"},React.createElement("rect",{"width":"44","height":"44","fill":"white","transform":"translate(44) rotate(90)"})))]);
}

TestimonialsNavRight.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = TestimonialsNavRight;

TestimonialsNavRight.default = TestimonialsNavRight;
